import type { ReactElement } from 'react'
import type { Brand } from '@ftk-connector/shared'

import { Avatar } from '../ui/Avatar'
import type { AvatarSize } from '../ui/Avatar'

export interface BrandAvatarProps {
  brand: Pick<Brand, 'name' | 'avatarUrl' | 'color'>
  size?: AvatarSize
  /** Draws the brand's identity colour as a ring — a permitted structure device. */
  ring?: boolean
  surface?: 'paper' | 'chrome'
  className?: string
}

/** A brand's mark: square, with its identity colour as a ring rather than a fill. */
export const BrandAvatar = ({
  brand,
  size = 'sm',
  ring = true,
  surface = 'paper',
  className,
}: BrandAvatarProps): ReactElement => (
  <Avatar
    name={brand.name}
    src={brand.avatarUrl}
    size={size}
    shape="square"
    surface={surface}
    ringColor={ring ? brand.color : undefined}
    className={className}
  />
)
